import React from 'react';

import { MCButton, Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { withRouter } from 'src/helpers';

import model from './model';
import appModel from 'src/model';
import { BASE_ICONS } from 'src/components/svg';
import LANG_CONST from 'src/helpers/lang/const';

class OAuth extends BaseComponent {
  state = { error: null };
  componentDidMount() {
    model.subscribe(this.subscription);
    const paramsObject = Object.fromEntries(new URLSearchParams(this.props.router.location.search));

    model.check(paramsObject.code, (error, data) => {
      let signupData = appModel.state.signupData;
      if (data.ok) {
        if (data.session) {
          model.emit('auth', data.session);
          this.navigate('/');
        } else {
          let url =
            signupData?.role === 'doctor'
              ? '/signup-doctor'
              : signupData?.role === 'clinic'
                ? '/signup-clinic'
                : '/signup';
          const params = {
            gid_token: data.gid_token
          };
          if (signupData?.inviteCode) {
            params.code = signupData.inviteCode;
          }
          if (signupData?.clinicUsername) {
            params.clinicUsername = signupData.clinicUsername;
          }
          this.navigate(url + '?' + new URLSearchParams(params));
        }
      } else {
        this.setState({ error: LANG_CONST.text.google_failed });
      }
    });
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const createState = model.getApiState('check');
    const { loading, errorMessage, invalid } = createState;

    if (createState.error === 'URLNAME_TAKEN') {
      invalid['username'] = createState.errorMessage;
      createState.error = null;
    }
    return loading ? (
      <div className={'mc-flex-col'} style={{ height: '100%' }}>
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      </div>
    ) : errorMessage || this.state.error ? (
      <div className={'mc-flex-col'} style={{ height: '100%' }}>
        <div className={'mc-m-auto mc-flex-20-col'}>
          <span className={'mc-error'}>{errorMessage || this.state.error}</span>
          <MCButton
            iconname={BASE_ICONS.BACK_ARROW}
            label={LANG_CONST.buttons.back_to_app}
            primary
            transparent
            onClick={(e) => {
              e.preventDefault();
              this.navigate('/');
            }}
          />
        </div>
      </div>
    ) : null;
  }
}

export default withRouter(OAuth);
